import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, X } from 'lucide-react';
const names = ['Luciana', 'Martín', 'Florencia', 'Diego', 'Sofía', 'Hernán', 'Julieta', 'Facundo', 'Carolina', 'Alejandro', 'Valentina', 'Matías', 'Camila', 'Nicolás', 'Mariana'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'La Plata', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Juan', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 3000);
    // Then show randomly every 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-211">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-start gap-4" data-id="element-212">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-213">
            <ShoppingCart className="w-5 h-5 text-green-600" data-id="element-214" />
          </div>
          <div className="flex-1 pr-4" data-id="element-215">
            <p className="text-sm text-gray-800 font-medium leading-snug" data-id="element-216">
              <span className="font-bold" data-id="element-217">{currentBuyer.name}</span> de{' '}
              <span className="font-bold" data-id="element-218">{currentBuyer.city}</span> acaba de
              comprar el Pack Completo
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-219">Hace unos minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 absolute top-2 right-2" data-id="element-220">
            <X className="w-4 h-4" data-id="element-221" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}